import styled from 'styled-components'

export const Wrap = styled.div<{ $maxwidth?: number }>`
  background-color: ${props => props.theme.color.white};
  padding: 32px;
  border-radius: 16px;
  width: calc(100% - 20px);
  max-width: ${props => props.$maxwidth}px;
  max-height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    padding: 16px;
  }
`

export const Title = styled.div<{ $titlePosition?: 'right' | 'left' | 'center', $titleSize: 'small'  | 'medium' | 'large' }>`
  ${({ theme, $titleSize }) => ({
    small: theme.typography.h6,
    medium: theme.typography.h3,
    large: theme.typography.h2
  }[$titleSize])};
  color: ${props => props.theme.color.black};
  margin-bottom: ${({ $titleSize }) => ({
    small: '16px',
    medium: '24px',
    large: '32px'
  }[$titleSize])};
  text-align: ${props => props.$titlePosition};

  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    ${({ theme, $titleSize }) => ({
      small: theme.typography.h6,
      medium: theme.typography.h4,
      large: theme.typography.h3
    }[$titleSize])};
    margin-bottom: ${({ $titleSize }) => ({
      small: '16px',
      medium: '16px',
      large: '24px'
    }[$titleSize])};
  }
`

export const ButtonWrapper = styled.div<{ $buttonPosition?: 'start' | 'end' | 'center', $stretch?: boolean }>`
  display: flex;
  justify-content: ${({ $stretch, $buttonPosition }) =>
    $stretch
      ? 'stretch'
      : ({
          start: 'flex-start',
          end: 'flex-end',
          center: 'center'
        }[$buttonPosition ?? 'end'])
  };
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px dashed ${props => props.theme.color.linkwater};
  & > * {
    ${({ $stretch }) => $stretch && `
      flex: 1;
    `}
  }
  @media screen and (max-width: ${props => props.theme.resolution.mdx}) {
    margin-top: 16px;
    padding-top: 16px;
  }
  @media screen and (max-width: ${props => props.theme.resolution.sm}) {
    flex-wrap: wrap;
    & > * {
      width: 100%;
    }
  }
`
